import React, { useMemo, useState } from "react"
import Img from "gatsby-image"
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md"

import ImageZoom from "./imageZoom"
import * as ShopItemImageCarouselStyles from "./shopItemImageCarousel.module.css"

const ShopItemImageCarousel = ({ images, thumbImages }) => {
  const [ index, setIndex ] = useState(0)

  const selectImage = i => setIndex(i)

  // TODO: translate picture to the right
  const leftArrowPressHandler = () => setIndex(index > 0 ? (index - 1) : (images.length - 1))

  // TODO: translate picture to the left
  const rightArrowPressHandler = () => setIndex(index < images.length - 1 ? (index + 1) : 0)

  let carouselImages = useMemo(() => images.map((image, index) => (
    <div
      className={ShopItemImageCarouselStyles.selectedImageWrapper}
      key={`image-${index}`}
    >
      <ImageZoom
        // className={ShopItemImageCarouselStyles.selectedImage}
        image={image}
      />
    </div>
  )), [images])

  let carouselThumbImages = useMemo(() => thumbImages.map((thumbImage, i) => (
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    <button
      className={[
        ShopItemImageCarouselStyles.thumbnailImage,
        index === i ? ShopItemImageCarouselStyles.active : "",
      ].join(" ")}
      onClick={selectImage.bind(this, i)}
      key={`thumb-${i}`}
      tabIndex={0}
      aria-checked={index === i ? true : false}
      role="checkbox"
      title="Select this image to view it larger"
    >
      <Img fixed={thumbImage.fixed} alt='Showcases product'/>
    </button>
  )), [thumbImages, index])

  return (
    <div>
      <div className={ShopItemImageCarouselStyles.container}>
        <button
          className={[
            ShopItemImageCarouselStyles.arrow,
            ShopItemImageCarouselStyles.left,
          ].join(" ")}
          onClick={leftArrowPressHandler}
          title='Previous image'
        >
          <MdKeyboardArrowLeft />
        </button>

        <div className={ShopItemImageCarouselStyles.selectedImageContainer}>
          {carouselImages[index]}
        </div>

        <button
          className={[
            ShopItemImageCarouselStyles.arrow,
            ShopItemImageCarouselStyles.right,
          ].join(" ")}
          onClick={rightArrowPressHandler}
          title='Next image'
        >
          <MdKeyboardArrowRight />
        </button>
      </div>
      <div className={ShopItemImageCarouselStyles.thumbnailImagesContainer}>
        {carouselThumbImages}
      </div>
    </div>
  )
}

export default ShopItemImageCarousel
